'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'loveseat';
var width = 512;
var height = 512;
var aliases = ["couch-small"];
var unicode = 'f4cc';
var svgPathData = 'M144 272C144 224.7 109.8 185.4 64.8 177.5 72 113.6 126.2 64 192 64l128 0c65.8 0 120 49.6 127.2 113.5-45 8-79.2 47.2-79.2 94.5l0 32-224 0 0-32zM64 448c-35.3 0-64-28.7-64-64L0 272c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 320 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 35.3-28.7 64-64 64 0 17.7-14.3 32-32 32s-32-14.3-32-32l-256 0c0 17.7-14.3 32-32 32s-32-14.3-32-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLoveseat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;